<template>
	<nav class="topbar">
		<spaceselect></spaceselect>
	</nav>
</template>

<script>
import Spaceselect from "../spaces/Spaceselect.vue"
export default {
	name: 'topbar',
	components: {
		Spaceselect
	},
	data() {
		return {

		}
	}
}
</script>

<style lang="sass">
.topbar
	height: 50px
	position: absolute
	left: 0
	top: 0
	width: 100%
	padding-left: 60px
	background: linear-gradient(270deg, #2BA3CF, #22B6B4)

</style>



// WEBPACK FOOTER //
// Topbar.vue?ed8d3da4